export class SendFeedbackEmailConstants {
  public static Input = {
    MaxLength: 100,
  };
}
